module.exports = __webpack_public_path__ + "img/ico-user-circle.9bff3b84.svg";